var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getOfflineSourceRegisterData, getOfflineTrackingRegisterData, } from "@jti/fe-common";
export const transformToCasConsents = (data) => {
    const { purposes } = data;
    if (!purposes)
        return [];
    return Object.entries(purposes).map(([key, value]) => ({
        id: key,
        accepted: value.toString() === "true",
    }));
};
export const transformToCasUser = (data, preferredLanguage) => {
    const { telephone, custom_attributes = {}, email = "", gender } = data, registerData = __rest(data, ["telephone", "custom_attributes", "email", "gender"]);
    return Object.assign(Object.assign(Object.assign({}, registerData), { consents: transformToCasConsents(data), email, phone: telephone, custom_attributes: Object.assign(Object.assign({}, custom_attributes), { preferredLanguage }), source: getOfflineSourceRegisterData(), tracking: getOfflineTrackingRegisterData() }), (gender && { gender: gender.value }));
};
